import React from 'react'
import * as S from './styled'
import type { Props } from './types'

export const ActivityIndicator = ({ children }: Props) => {
  return <S.ActivityIndicator>{children}</S.ActivityIndicator>
}
